/*
 * Copyright (c) 2026, Gather
 * https://gather.life
 */

import { useMarketplaceVehicleCatalogMgmtClient } from './use-marketplace-vehicle-catalog-mgmt-client';
import { useUserId } from './use-user-id';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useSearchHistory() {
  const userId = useUserId();

  const { client } = useMarketplaceVehicleCatalogMgmtClient();

  return client.useQuery(
    'get',
    '/users/{userId}/catalog/search-history',
    {
      params: { path: { userId: userId ?? '' } },
    },
    {
      retry: 3,
      enabled: userId != null,
    }
  );
}
